import { environment } from '@environments/environment';

export const HOME_ROUTE = 'inicio';
export const INSTALLMENT_PAYMENT_ROUTE = 'pagar-cuota';
export const INSTALLMENT_PAYMENT_ROUTE_CONFIRMATION = 'pagar-cuota/comprobante';
export const CONSUMER_CREDIT_ROUTE = 'credito-de-consumo';
export const SECTION_ROUTE = 'seccion';
export const CONTACT_US_SINGLE_ROUTE = 'atencion-al-cliente';
export const CONTACT_US_ROUTE = `${SECTION_ROUTE}/${CONTACT_US_SINGLE_ROUTE}`;
export const FAQS_SINGLE_ROUTE = 'preguntas-frecuentes';
export const FAQS_ROUTE = `${CONTACT_US_ROUTE}/${FAQS_SINGLE_ROUTE}`;
export const OFFICES_SINGLE_ROUTE = 'sucursales';
export const OFFICES_ROUTE = `${CONTACT_US_ROUTE}/${OFFICES_SINGLE_ROUTE}`;
export const RATES_AND_FEES_SINGLE_ROUTE = 'tasas-y-tarifas';
export const RATES_AND_FEES_ROUTE = `${CONTACT_US_ROUTE}/${RATES_AND_FEES_SINGLE_ROUTE}`;
export const PORTABILITY_SINGLE_ROUTE = 'portabilidad-financiera';
export const PORTABILITY_ROUTE = `${CONTACT_US_ROUTE}/${PORTABILITY_SINGLE_ROUTE}`;
export const NORMATIVE_INFORMATION_AND_LEGAL_BASES_SINGLE_ROUTE = 'informacion-normativa-y-bases-legales';
export const NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE = `${CONTACT_US_ROUTE}/${NORMATIVE_INFORMATION_AND_LEGAL_BASES_SINGLE_ROUTE}`;
export const ASK_FOR_CARD_SINGLE_ROUTE = 'tarjeta';
export const ASK_FOR_CARD_ROUTE = `${environment.TCV_SITE}/${ASK_FOR_CARD_SINGLE_ROUTE}`;
